import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import ChevronLeft from '../../../assets/icons/chevron-left.svg'
import ChevronRight from '../../../assets/icons/chevron-right.svg'
import IconBadge from '../../../components/Pagination/IconBadge'
import { useIntl } from '../../../localization/react'

interface Props {
  isFirstPage: boolean
  handleBack: () => void
  handleForward: () => void
}

const Pagination = ({ isFirstPage, handleBack, handleForward }: Props) => {
  const intl = useIntl()
  return (
    <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={4} sx={{ margin: 1 }}>
      {!isFirstPage && (
        <IconBadge onClick={handleBack} ariaLabel={intl.scrollLeftLabel()}>
          <Icon src={ChevronLeft} size="default" color="darkgray" />
        </IconBadge>
      )}
      <IconBadge onClick={handleForward} ariaLabel={intl.scrollRightLabel()}>
        <Icon src={ChevronRight} size="default" color="darkgray" />
      </IconBadge>
    </Stack>
  )
}

export default Pagination
